import { render, staticRenderFns } from "./PCAnnouncement.vue?vue&type=template&id=19704516&"
import script from "./PCAnnouncement.vue?vue&type=script&lang=js&"
export * from "./PCAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports